/**
 * Client-side builders for IS1 (legacy) deep-links. IS1 base comes from
 * `NEXT_PUBLIC_IS1_URL` (inlined at build time, see next.config.js); in
 * deployed environments that base already includes the `/public/` prefix.
 */

/**
 * IS1 "Zápis o utkání" (match report) URL keyed by the match publish id (GUID),
 * e.g. `${base}/zapasy/zapis-o-utkani.aspx?zapas=<guid>`. Returns undefined when
 * the base env or the GUID is missing so callers can render a plain label
 * instead of a broken link.
 */
export const buildIs1MatchReportUrl = (
    matchPublishId: string | null | undefined
): string | undefined => {
    const base = process.env.NEXT_PUBLIC_IS1_URL;
    if (!base || !matchPublishId) {
        return undefined;
    }
    return `${base}/zapasy/zapis-o-utkani.aspx?zapas=${matchPublishId}`;
};
